module.exports = __webpack_public_path__ + "media/images/default/shared/wave-74e4652dd94e10d5dc0bdbf1ebec38e3.svg";